//Audio
import {Howl} from 'howler';
// import chillAudio from "../Assets/chill-piano-melody_155bpm_D_minor.wav"
// import pianoTest from "../Assets/nf-type-piano-melody_156bpm.wav"
// import softPiano from "../Assets/reflective-soft-piano-quiet-melody_157bpm_D_minor.wav"
import shamiSession from "../Assets/ShamiSession.wav"

const audioFiles =[shamiSession]

export const BGMusic = new Howl({
  src: [audioFiles[0]],
  autoplay: false,
  loop: true,
  volume: .5
});

export function playBGMusic(){
    return BGMusic.play();
}